<template>
	<div>
		<h3>제1조 총칙</h3>

		<ol class="order-list">
			<li class="order-list__item">
				개인정보란 생존하는 개인에 관한 정보로서 당해 정보에 포함되어 있는 성명
				등의 사항에 의하여 당해 개인을 식별할 수 있는 정보 (당해 정보만으로는
				특정 개인을 식별할 수 없더라도 다른 정보와 용이하게 결합하여 식별할 수
				있는 것을 포함)를 말합니다.
			</li>
			<li class="order-list__item">
				&lt;(유)하이모&gt;('http://www.himo.co.kr'이하 '하이모')은(는)
				((유)하이모가 운영하는 하이모, 하이모레이디, 하이몰을 통틀어 말하며 이하
				"하이모"라고 합니다) 회원의 개인정보를 매우 중요시하고, 『정보통신망
				이용촉진 및 정보보호 등에 관한 법률』, 『개인정보보호법』 등의 관련
				법률을 준수하고 있으며, 그에 의거한 개인정보처리방침을 정하여 이용자의
				권익보호에 최선을 다하고 있습니다.
			</li>
			<li class="order-list__item">
				당사는 개인정보처리방침을 통하여 회원께서 제공하시는 개인정보가 어떠한
				용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가
				취해지고 있는지 알려드립니다.
			</li>
			<li class="order-list__item">
				당사는 개인정보처리방침을 홈페이지 첫 화면에 공개함으로써 회원께서
				언제나 용이하게 보실 수 있도록 조치하고 있습니다.
			</li>
		</ol>

		<h3>제2조 수집하는 개인정보 항목 및 방법</h3>
		<ol class="order-list">
			<li class="order-list__item">
				&lt;(유)하이모&gt;('http://www.himo.co.kr'이하 '하이모')은(는)
				개인정보를 다음의 목적을 위해 처리합니다.<br />

				처리한 개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이
				변경될 시에는 사전 동의를 구할 예정입니다.<br /><br />

				개인정보는 다음의 목적이외의 용도로는 사용되지 않으며 이용 목적이 변경될
				시에는 사전동의를 구할 예정입니다.<br />

				홈페이지 회원가입 및 관리회원 가입의사 확인, 회원자격 유지•관리, 서비스
				부정이용 방지, 각종 고지•통지, 분쟁 조정을 위한 기록 보존 등을 목적으로
				개인정보를 처리합니다.<br /><br />

				①개인정보의 수집항목 및 이용목적<br /><br />

				1) 통합회원 가입시<br />

				필수항목 : 자택주소, 비밀번호, 생년월일, 성별, 로그인ID, 휴대전화번호,
				이름, 이메일,<br />

				서비스 이용 기록, 접속 로그<br />

				※휴대전화번호, 이메일 마케팅 수신 동의여부항목은 입력하지 않아도
				회원가입 가능<br /><br />

				2) 통합회원 가입 관련 본인확인 필요 시<br />

				- 이름, 생년월일, 성별 등 본인확인에 필요한 정보<br /><br />

				3) 위치기반서비스 가입 시<br />

				- 회원 ID, 모바일단말기 식별번호, 모바일단말기 OS정보, 모델명, 배터리
				잔량, 위치정보서비스 제공을 위한 정보(사용시각, 장소 등), 서비스
				이용기록, 접속로그<br /><br />

				4)서비스 이용과정 및 사업 처리과정에서 수집될 수 있는 개인정보의 범위<br />

				- 서비스 이용 및 중지기록, 접속로그, 쿠키, 접속IP정보<br />

				- 제품 결제정보, 포인트정보, 거래정보<br />

				- 제품 배송을 위한 수취인 주소, 수취인명,수취인연락처 등 배송정보<br />

				- (모바일기기 이용시) 단말기식별번호, 단말기OS정보, 광고 식별자,
				이동통신회사<br /><br />

				5) 이용 목적<br />
				회사는 아래와 같은 목적을 위해 최소한의 개인정보를 수집합니다.<br />
				1. 서비스제공 - 이용자가 제공한 정보를 기반으로 고객자료와 매칭, 지점
				예약 및 회원등급, 보유 마일리지/쿠폰 확인 등의 서비스 기능 제공을 위해
				개인정보를 수집합니다.<br />
				2. 서비스 개발 및 개선 - 인구통계학적 분석, 서비스 이용 및 지점방문
				기록의 분석 등 향후 서비스 개선에 활용<br /><br />

				②개인정보의 수집방법<br />

				- 홈페이지,상담게시판,전화,팩스,이벤트응모,배송요청<br />

				- 로그 분석 프로그램을 통한 생성정보 수집 ,쿠키(cookie)에 의한 정보
				수집<br />

				- 관계사 및 구매자로부터의 제공<br />

				- 스마트폰용 어플리케이션을 통한 수집<br /><br />

				<strong class="u-font-weight-500">자동 생성 정보</strong><br />
				서비스 이용 과정에서 단말기정보, IP주소, 쿠키, 방문일시, 부정이용기록,
				서비스 이용 기록 등의 정보가 자동으로 생성되어 수집될 수 있습니다.
			</li>
			<li class="order-list__item">
				비회원 고객
				<div>
					하이모에서 운영하는 사이트에서는 회원 외에도 비회원 고객 또한 상품을
					구매할 수 있습니다. 이러한 경우 배송, 대금 결제, 서비스 안내 등을 위해
					최소한의 개인정보(주문자이름, 주소, 연락처, 이메일, 수령인 정보,
					대금결제 및 환불에 관한 정보 등)만을 요청하여 동의를 구합니다.
				</div>
			</li>
			<li class="order-list__item">
				허위 정보 입력 시 당사의 조치
				<div>
					회원은 자신의 정보에 대해 정확성 및 적법성을 보장해야 합니다.<br />
					만약 이를 위반하여 타인의 정보를 도용하는 등 각종 방법으로 허위 정보를
					입력할 경우 당사는 해당 회원을 관계법령에 따라 신고 할 수 있으며 강제
					탈퇴를 시킬 수도 있습니다.
				</div>
			</li>
			<li class="order-list__item">
				회원이 자발적으로 공개한 개인정보로 인해 회원 개인에게 발생하는 손실이나
				문제는 전적으로 개인의 책임이며, 공개적인 공간에 게재되는 개인정보는
				다른 사람이 수집하여 무단으로 사용할 수 있음을 인지하시어, 이로 인해
				원하지 않는 피해를 입을 수 있음을 유념하시기 바랍니다.
			</li>
			<li class="order-list__item">
				회사는 모바일 앱 서비스를 위하여 아래와 같이 고객의 이동통신단말기 내
				정보 및 기능에 접근, 이용할 수 있습니다. 접근항목은 앱 설치시 또는 최초
				실행시 안내 및 동의를 받습니다.<br />
				접근항목의 경우 OS버전에 따라 동의 받는 방법이 다를 수 있으며, 접근
				권한에 동의하지 않으면 일부 서비스 사용이 불가능합니다.

				<ul class="dot-list">
					<li class="dot-list__item">
						※접근항목: 기기 및 앱 기록권한, 기기 사진,미디어,파일액세스,
						사진찍기 및 동영상녹화
					</li>
					<li class="dot-list__item">
						※접근권한에 동의하지 않으면, 하이모 스타일러 앱 사용시 이미지
						불러오기 저장이 불가 능하며, 서비스 이용이 제한됩니다.
					</li>
					<li class="dot-list__item">
						※자동수집항목: PC웹, 모바일 웹/앱 이용 과정에서 단말기
						정보(OS,화면사이즈,디바이스), IP주소, 쿠키, 방문일시, 부정이용기록,
						서비스 이용 기록 등의 정보가 자동으로 생성되어 수집됩니다. (개인을
						특정할 수 있는 정보는 기록되지 않습니다)
					</li>
					<li class="dot-list__item">
						※하이모 스타일러 모바일 앱을 통해 생성된 모든 이미지는 개인의
						창작물로 인정되며, 생성된 이미지는 기기에만 저장됩니다.
					</li>
				</ul>
			</li>
		</ol>

		<h3>제3조 개인정보처리 위탁</h3>
		<ol class="order-list">
			<li class="order-list__item">
				(유)하이모는 개인정보 업무처리를 위한 개인정보 처리업무를 위탁하고
				있습니다.
				<br />
				<table class="u-table" border="1">
					<colgroup>
						<col />
						<col />
					</colgroup>
					<thead>
						<tr>
							<th>업무</th>
							<th>수탁자</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>회원정보 운영/관리업무</td>
							<td>위탁 없음</td>
						</tr>
						<tr>
							<td>불만 접수 처리등 민원 처리 업무</td>
							<td>위탁 없음</td>
						</tr>
						<tr>
							<td>문자메세지/ 카카오 알림톡 발송업무</td>
							<td>(주)다우기술 비즈뿌리오</td>
						</tr>
						<tr>
							<td>상품 배송업무/도착 정보 등 서비스제공</td>
							<td>하이모 / 배송협력사:우체국택배,로젠택배</td>
						</tr>
						<tr>
							<td>이벤트 업무처리</td>
							<td>(주)애딕티브</td>
						</tr>
					</tbody>
				</table>
			</li>
		</ol>
		<strong>*수탁자가 없는 경우 하이모에서 자체적으로 업무를 진행</strong><br />
		① &lt;(유)하이모&gt;('http://www.himo.co.kr'이하 '하이모')은(는) 위탁계약
		체결시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지,
		기술적 보호조치, 재위탁 제한, 수탁자에 대한 관리감독, 손해배상 등 책임에
		관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게
		처리하는지를 감독하고 있습니다.<br />
		② 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보
		처리방침을 통하여 공개하도록 하겠습니다.<br /><br />
		<ol class="order-list" start="2">
			<li class="order-list__item">
				(유)하이모는 개인정보 수집.이용 목적에서 명시한 범위 내에서 사용하며,
				원칙적으로 회원의 사전 동의없이 개인정보 수집.이용 목적 범위를 초과하여
				이용하거나 회원의 개인정보를 제공하지 않습니다. 서비스 이용 과정에서 제
				3자에게 제공되는 정보 및 제공된 정보의 이용 목적은 다음과 같습니다.

				<table class="u-table">
					<colgroup>
						<col />
						<col />
						<col />
						<col />
					</colgroup>
					<thead>
						<tr>
							<th scope="col">개인정보를 제공받는 자</th>
							<th scope="col">제공목적</th>
							<th scope="col">제공항목</th>
							<th scope="col">보유 및 이용기간</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>(주)다우기술 비즈뿌리오</td>
							<td>알림톡 전송</td>
							<td>회원의 휴대전화번호</td>
							<td>회원 탈퇴시 또는 서비스 종료시까지</td>
						</tr>
						<tr>
							<td>(주)애딕티브</td>
							<td>이벤트 업무처리</td>
							<td>회원의 휴대전화번호</td>
							<td>회원 탈퇴시 또는 서비스 종료시까지</td>
						</tr>
					</tbody>
				</table>
			</li>
		</ol>

		<br />

		<h3>제4조 개인정보의 처리 및 보유 기간</h3>
		<ul>
			<li>
				① 하이모는 개인정보의 수집목적 또는 제공받은 목적이 달성된 때(회원
				탈퇴시)에는 회원의 개인정보를 지체없이 즉시 파기합니다.
			</li>
			<li>
				② 개인정보 보유 이용기간은 관련법령을 준수합니다<br /><br />
				- 관련법령 :<br />

				소비자의 불만 또는 분쟁처리에 관한 기록 : 3년,<br />

				신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년,<br />

				대금결제 및 재화 등의 공급에 관한 기록 : 5년,<br />

				표시/광고에 관한 기록 : 6개월
			</li>
		</ul>

		<br />

		<h3>제5조 이용자 및 법정대리인의 개인정보 보호 관련 권리 및 행사방법</h3>

		<p>
			정보주체의 권리,의무 및 그 행사방법 이용자는 개인정보주체로서 다음과 같은
			권리를 행사할 수 있습니다.
		</p>

		<ul>
			<li>
				① 정보주체는 (유)하이모('http://www.himo.co.kr'이하 '하이모') 에 대해
				언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.<br /><br />

				1) 개인정보 열람요구<br />

				2) 오류 등이 있을 경우 정정 요구<br />

				3) 삭제요구<br />

				4) 처리정지 요구
			</li>

			<li>
				② 제1항에 따른 권리 행사는(유)하이모('http://www.himo.co.kr'이하
				'하이모') 에 대해 개인정보 보호법 시행규칙 별지 제8호 서식에 따라 서면,
				전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며
				&lt;기관/회사명&gt;('사이트URL'이하 ‘사이트명) 은(는) 이에 대해 지체
				없이 조치하겠습니다.
			</li>

			<li>
				③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는
				&lt;기관/회사명&gt;('사이트URL'이하 '사이트명') 은(는) 정정 또는 삭제를
				완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.
			</li>

			<li>
				④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등
				대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지
				제11호 서식에 따른 위임장을 제출하셔야 합니다.
			</li>
		</ul>

		<br />

		<h3>제6조 개인정보 파기 절차 및 방법</h3>

		<p>
			개인정보의 파기&lt;(유)하이모&gt;('하이모')은(는) 원칙적으로 개인정보
			처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의
			절차, 기한 및 방법은 다음과 같습니다.
		</p>
		<p>
			('하이모')은 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당
			개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.
		</p>

		<ul>
			<li>
				① 파기절차<br />
				이용자가 입력한 정보는 목적 달성 후 별도의 DB에 옮겨져(종이의 경우
				별도의 서류) 내부 방침 및 기타 관련 법령에 따라 일정기간 저장된 후 혹은
				즉시 파기됩니다. 이 때, DB로 옮겨진 개인정보는 법률에 의한 경우가
				아니고서는 다른 목적으로 이용되지 않습니다.
			</li>
			<li>
				② 파기기한<br />
				이용자의 개인정보는 개인정보의 보유기간이 경과된 경우에는 보유기간의
				종료일로부터 5일 이내에, 개인정보의 처리 목적 달성, 해당 서비스의 폐지,
				사업의 종료 등 그 개인정보가 불필요하게 되었을 때에는 개인정보의 처리가
				불필요한 것으로 인정되는 날로부터 5일 이내에 그 개인정보를 파기합니다.
			</li>
			<li>
				③ 파기방법<br />
				전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을
				사용합니다.<br />
				종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
			</li>
		</ul>
		<br />

		<h3>제7조 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</h3>

		<p>
			회사는, 이용자의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)'를
			운용합니다.<br />
			쿠키는 회사의 홈페이지, 웹서비스, 모바일앱을 운영하는데 이용되는 서버가
			이용자의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의 컴퓨터나
			모바일 기기의 하드디스크에 저장됩니다. 회사는, 이용자가 서비스에 접속한
			상태에서 사용자 인증을 위하여 쿠키를 이용하고 있습니다. 쿠키 이용에 대한
			선택권은 이용자가 가지고 있습니다. 이용자의 웹브라우저에서 모든 쿠키를
			허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을
			거부하는 등의 옵션을 선택하실 수 있습니다. 설정방법은 인터넷 익스플로러의
			경우 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 에서 선택하실 수
			있습니다. 단, 쿠키의 저장을 거부하는 옵션을 선택하시는 경우에는 서비스
			이용에 불편이 야기될 수 있습니다.
		</p>

		<br />

		<h3>제8조 개인정보 안정성 확보조치</h3>

		<p>
			개인정보의 안전성 확보 조치 &lt;(유)하이모&gt;('하이모')은(는)
			개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한
			기술적/관리적 및 물리적 조치를 하고 있습니다.
		</p>

		<p>
			('하이모')은 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한
			기술적/관리적 및 물리적 조치를 하고 있습니다.
		</p>

		<ul>
			<li>
				① 개인정보 처리 직원의 최소화 및 교육<br />

				개인정보를 취급하는 직원을 지정하고 담당자에 한정시켜 최소화 하여
				개인정보를 관리하는 대책을 시행하고 있습니다.
			</li>

			<li>
				② 정기적인 자체 감사 실시<br />

				개인정보 처리 관련 안정성 확보를 위해 정기적(분기 1회)으로 자체 감사를
				실시하고 있습니다.
			</li>

			<li>
				③ 개인정보의 암호화<br />

				이용자의 개인정보는 비밀번호는 암호화 되어 저장 및 관리되고 있어,
				본인만이 알 수 있으며 중요한 데이터는 파일 및 전송 데이터를 암호화
				하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
			</li>

			<li>
				④ 개인정보에 대한 접근 제한<br />

				개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의
				부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를
				하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고
				있습니다.
			</li>

			<li>
				⑤ 문서보안을 위한 잠금장치 사용<br />

				개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에
				보관하고 있습니다.
			</li>

			<li>
				⑥ 비인가자에 대한 출입 통제<br />

				개인정보를 보관하고 있는 물리적 보관 장소를 별도로 두고 이에 대해
				출입통제 절차를 수립, 운영하고 있습니다.
			</li>
		</ul>
		<br />

		<h3>제9조 개인정보 보호책임자 작성</h3>
		<p>
			① &lt;(유)하이모&gt;('http://www.himo.co.kr'이하 '하이모') 은(는) 개인정보
			처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의
			불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를
			지정하고 있습니다.
		</p>

		<table class="u-table">
			<colgroup>
				<col />
				<col />
			</colgroup>
			<thead>
				<tr>
					<th scope="col">개인정보 보호책임자</th>
					<th scope="col">개인정보 보호 담당부서</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>
						성명: 성길태<br />
						부서: 전산팀<br />
						직급: 부장<br />
						연락처: 070-4034-5070, sungkt@himo.com, 02-3474-5165<br />

						※ 개인정보 보호 담당부서로 연결됩니다.
					</td>
					<td>
						담당자: 임재성<br />

						부서명: 기획팀<br />

						직급: 계장<br />

						연락처: 070-4034-5063, skys17@himo.com, (F)02-3474-5165
					</td>
				</tr>
			</tbody>
		</table>

		<p>
			② 정보주체께서는 (유)하이모('http://www.himo.co.kr'이하 '하이모') 의
			서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의,
			불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로
			문의하실 수 있습니다. (유)하이모(‘http://www.himo.co.kr’이하 ‘하이모)
			은(는) 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
		</p>

		<br />

		<h3>제10조 개인정보 처리방침 변경</h3>
		<p>
			① 이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른
			변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터
			공지사항을 통하여 고지할 것입니다.
		</p>

		<br />
		<div class="d-flex justify-end">
			<Btn small @click="openHistoryPrivacy"
				>변경 전 개인정보 처리 방침 보기</Btn
			>
		</div>
	</div>
</template>

<script>
import Btn from '@/components/common/Btn';

export default {
	components: {
		Btn,
	},
	methods: {
		openHistoryPrivacy() {
			this.$openOverlayModal();
			this.$setOverlayModalTitle({ title: '다른 개인정보 처리 방침 보기' });
			this.$setOverlayContentComp({
				component: async () =>
					(await import('@/components/PrivacyHistoryItems.vue')).default,
			});
		},
		test() {},
	},
};
</script>

<style scoped>
h3 {
	font-weight: 700;
}
</style>
